






























































import { Component, Vue } from "vue-property-decorator";
import { HandbookCategory, HandbookCategoryResponseList } from "@/api";
import Loading from "@/components/loader/loading.vue";
import HandbookCategoryForm from "@/views/admin/handbook/HandbookCategoryForm.vue";

@Component({
  components: {
    Loading,
    HandbookCategoryForm,
  },
})
export default class HandbookCategoryList extends Vue {
  loading = false;
  dialog = false;
  search = "";
  count = 0;
  category = {} as HandbookCategory;

  async created() {
    this.loading = true;
    await this.$store.dispatch("handbook/fetchCategories");
    this.loading = false;
  }

  get categories() {
    return (
      (this.$store.getters[
        "handbook/categories"
      ] as HandbookCategoryResponseList) || []
    );
  }

  isActive(id: number): boolean {
    const currentId = Number(this.$route.params.categoryId) || 0;
    return id == currentId;
  }

  selectCategory(id: number) {
    this.$router.push({
      path: `/admin/company-handbook/details/${id}`,
    });
  }

  clearSearch() {
    this.search = "";
  }
}
